import { resolveId } from '@medplum/core'
import type { Reference } from '@medplum/fhirtypes'
import { getType } from '@seen/core/utils'
import { useFhirReadHistory } from '#src/hooks/useFhirReadHistory.ts'

interface UseCreatedOnResult {
  data: string | undefined
  isLoading: boolean
}

export function useCreatedOn(reference: Reference): UseCreatedOnResult {
  const { data: history, isLoading } = useFhirReadHistory(
    getType(reference),
    resolveId(reference)
  )
  const oldestVersionResource = history?.entry?.at(-1)?.resource
  const createdOn = oldestVersionResource?.meta?.lastUpdated
  return { data: createdOn, isLoading }
}
